import { denormalize } from "normalizr";

import { getEntities } from "./entities";
import { postSchema } from "../schemas";

export const DEFAULT_MODIFICATION = "form";

export function getPost(state, id) {
  return denormalize(id, postSchema, getEntities(state));
}
